export const expandText = () => {

	let els = document.querySelectorAll('[data-expanded="false"]')

	if (!els.length) return

	els.forEach(el => {

		let button = el.querySelector('button')

		button.addEventListener('click', () => {
			el.dataset.expanded = true
		})
	})
}

export default () => { }